import React, { useState } from "react";
import { mediaUrl } from "@/lib/api";

/**
 * BookCover — renders an uploaded cover image when `coverUrl` is provided,
 * otherwise falls back to a typographic accent placeholder. The placeholder
 * is intentionally dignified (no stock imagery) until the publisher supplies
 * the real cover via the Media Library.
 */
export const BookCover = ({
  title,
  accent = "maroon",
  series = "Glories of India Series",
  size = "md",
  coverUrl,
  altText,
}) => {
  const [failed, setFailed] = useState(false);
  const sizeClasses = { sm: "text-[18px]", md: "", lg: "" };

  if (coverUrl && !failed) {
    return (
      <div
        className={`book-cover book-cover--image book-cover--${accent}`}
        data-testid={`book-cover-image-${accent}`}
      >
        <img
          src={mediaUrl(coverUrl)}
          alt={altText || `Book cover: ${title}`}
          onError={() => setFailed(true)}
          loading="lazy"
        />
      </div>
    );
  }

  return (
    <div
      className={`book-cover book-cover--${accent}`}
      data-testid={`book-cover-${accent}`}
      role="img"
      aria-label={`Book cover: ${title}`}
    >
      <div className="overline">{series}</div>
      <div className={`title ${sizeClasses[size] || ""}`}>{title}</div>
    </div>
  );
};

export default BookCover;
